<template>
  <div class="relative h-full">
    <div
      v-for="tick in ticks"
      :key="tick"
      class="absolute inset-y-0 border-l border-gray-light"
      :style="{left: `${tick * 100}%`}"
    />
    <div
      v-if="today >= 0 && today <= 1"
      class="absolute inset-y-0 border-l border-dashed border-red-light"
      :style="{left: `${today * 100}%`}"
    />
    <template v-if="!events">
      <Skeleton class="absolute top-1/2 -translate-y-1/2 inset-x-0 h-1.5 rounded-full" />
      <Skeleton
        v-for="placeholder in SKELETON_MARKERS"
        :key="placeholder"
        class="absolute top-1/2 -translate-x-1/2 -translate-y-1/2 size-6 rounded-full"
        :style="{left: `${placeholder * 100}%`}"
      />
    </template>
    <template v-else>
      <div
        v-if="clusters.length > 1"
        class="absolute top-1/2 h-0.5 -translate-y-1/2 bg-primary/20"
        :style="{left: `${clusters[0].position * 100}%`, width: `${(clusters[clusters.length - 1].position - clusters[0].position) * 100}%`}"
      />
      <FollowUpMarker v-for="cluster in clusters" :key="cluster.id" :cluster="cluster" />
    </template>
  </div>
</template>

<script setup lang="ts">
import {computed} from "vue";
import {Skeleton} from "@/core/components/ui/skeleton";
import FollowUpMarker from "@/program/components/program-follow-up/FollowUpMarker.vue";
import ProgramFollowUpService from "@/program/services/ProgramFollowUpService";
import {FollowUpEvent} from "@/program/interfaces/ProgramFollowUp";

/**
 * The minimal gap between two markers, as a fraction of the axis: closer
 * events are grouped in a single marker.
 */
const MARKER_GAP = 0.025;

/** The positions of the placeholder markers drawn while loading. */
const SKELETON_MARKERS = [0.18, 0.42, 0.67];

const props = defineProps<{
    /** The consumer events, undefined while loading. */
    events?: FollowUpEvent[];
    from: Date;
    to: Date;
    /** The month ticks positions, from 0 to 1. */
    ticks: number[];
    /** The today position, from 0 to 1. */
    today: number;
}>();

const clusters = computed(() => props.events
    ? ProgramFollowUpService.clusters(props.events, props.from, props.to, MARKER_GAP)
    : []);
</script>
